'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = 'M272-16l0 32 40 0 0 16-40 0 0 40-16 0 0-40-40 0 0-16 40 0 0-40 16 0 0 8zM452.7-1.9l11.3-11.3 11.3 11.3 70.6 70.6 11.3 11.3-11.3 11.3-422.6 422.6-11.3 11.3-11.3-11.3-70.6-70.6-11.3-11.3 11.3-11.3 422.6-422.6zM464 9.4L322.3 151 393 221.7 534.6 80 464 9.4zM41.4 432L112 502.6 381.7 233 311 162.3 41.4 432zM96 40l0 72 80 0 0 16-80 0 0 80-16 0 0-80-80 0 0-16 80 0 0-80 16 0 0 8zM480 320l0 80 80 0 0 16-80 0 0 80-16 0 0-80-80 0 0-16 80 0 0-80 16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;